import { createAction, props } from '@ngrx/store';

import { PickId } from '../../core/picks/pick-id';
import { SystemSlipType } from '../bet-generation/slip-type';
import { BetslipTypesActions } from '../types/actions';
import { ISystemBetPickState } from './state';

export default class BetslipSystemBetActions {
    static readonly ACTION_SCHEMA = `${BetslipTypesActions.ACTION_SCHEMA}/system-bet`;

    private static readonly ADD_PICK = `${BetslipSystemBetActions.ACTION_SCHEMA}/ADD_PICK`;
    private static readonly REQUEST_REMOVE_PICK = `${BetslipSystemBetActions.ACTION_SCHEMA}/REQUEST_REMOVE_PICK`;
    private static readonly REMOVE_PICK = `${BetslipSystemBetActions.ACTION_SCHEMA}/REMOVE_PICK`;
    private static readonly UPDATE_PICK_ORDER = `${BetslipSystemBetActions.ACTION_SCHEMA}/UPDATE_PICK_ORDER`;
    private static readonly TOGGLE_SYSTEM_EACH_WAY = `${BetslipSystemBetActions.ACTION_SCHEMA}/TOGGLE_SYSTEM_EACH_WAY`;
    private static readonly SET_SYSTEM_EACH_WAY = `${BetslipSystemBetActions.ACTION_SCHEMA}/SET_SYSTEM_EACH_WAY`;
    private static readonly SET_SYSTEM_BET_STAKE = `${BetslipSystemBetActions.ACTION_SCHEMA}/SET_SYSTEM_BET_STAKE`;
    private static readonly SET_SYSTEM_TYPE = `${BetslipSystemBetActions.ACTION_SCHEMA}/SET_SYSTEM_TYPE`;
    private static readonly TOGGLE_SYSTEM_BANKER = `${BetslipSystemBetActions.ACTION_SCHEMA}/TOGGLE_SYSTEM_BANKER`;
    private static readonly TOGGLE_SYSTEM_BET_PICK_BANKER = `${BetslipSystemBetActions.ACTION_SCHEMA}/TOGGLE_SYSTEM_BET_PICK_BANKER`;
    private static readonly UPDATE_SYSTEM_BET_PICK_STATE = `${BetslipSystemBetActions.ACTION_SCHEMA}/UPDATE_SYSTEM_BET_PICK_STATE`;
    private static readonly TOGGLE_EXPAND_LINEAR_SYSTEM_BET = `${BetslipSystemBetActions.ACTION_SCHEMA}/TOGGLE_EXPAND_LINEAR_SYSTEM_BET`;
    private static readonly CLICK_EXPAND_LINEAR_SYSTEM_BET = `${BetslipSystemBetActions.ACTION_SCHEMA}/CLICK_EXPAND_LINEAR_SYSTEM_BET`;
    private static readonly UPDATE_SYSTEM_TYPE_STAKES = `${BetslipSystemBetActions.ACTION_SCHEMA}/UPDATE_SYSTEM_TYPE_STAKES`;
    private static readonly CLICK_SYSTEM_TYPE_STAKE = `${BetslipSystemBetActions.ACTION_SCHEMA}/CLICK_SYSTEM_TYPE_STAKE`;
    private static readonly REMOVE_SYSTEM_BET_TYPE_STAKE = `${BetslipSystemBetActions.ACTION_SCHEMA}/REMOVE_SYSTEM_BET_TYPE_STAKE`;
    private static readonly SET_SYSTEM_BET_TYPE_STAKE = `${BetslipSystemBetActions.ACTION_SCHEMA}/SET_SYSTEM_BET_TYPE_STAKE`;
    private static readonly SET_SYSTEM_BET_TYPE_STAKE_VALUE = `${BetslipSystemBetActions.ACTION_SCHEMA}/SET_SYSTEM_BET_TYPE_STAKE_VALUE`;
    private static readonly SET_SYSTEM_BET_TYPE_EACHWAY = `${BetslipSystemBetActions.ACTION_SCHEMA}/SET_SYSTEM_BET_TYPE_EACHWAY`;
    private static readonly TOGGLE_SINGLE_BET_PICK = `${BetslipSystemBetActions.ACTION_SCHEMA}/TOGGLE_SINGLE_BET_PICK`;
    private static readonly ADD_PICK_WITH_NEW_PICKID = `${BetslipSystemBetActions.ACTION_SCHEMA}/ADD_PICK_WITH_NEW_PICKID`;

    static toggleSystemEachWay = createAction(BetslipSystemBetActions.TOGGLE_SYSTEM_EACH_WAY);
    static setSystemEachWay = createAction(BetslipSystemBetActions.SET_SYSTEM_EACH_WAY, props<{ isEachWay: boolean }>());
    static setSystemBetStake = createAction(
        BetslipSystemBetActions.SET_SYSTEM_BET_STAKE,
        props<{ stake: number | null; silent?: boolean; stakeStr?: string | null }>(),
    );

    static setSystemType = createAction(BetslipSystemBetActions.SET_SYSTEM_TYPE, props<{ systemType: SystemSlipType | null }>());
    static toggleSystemBanker = createAction(BetslipSystemBetActions.TOGGLE_SYSTEM_BANKER);
    static toggleSystemBetPickBanker = createAction(BetslipSystemBetActions.TOGGLE_SYSTEM_BET_PICK_BANKER, props<{ pickId: string }>());
    static updateSystemBetPickState = createAction(
        BetslipSystemBetActions.UPDATE_SYSTEM_BET_PICK_STATE,
        props<{ pickId: PickId; update: Partial<ISystemBetPickState> }>(),
    );

    static clickExpandLinearSystemBet = createAction(BetslipSystemBetActions.CLICK_EXPAND_LINEAR_SYSTEM_BET, props<{ isExpanded: boolean }>());
    static toggleExpandLinearSystemBet = createAction(BetslipSystemBetActions.TOGGLE_EXPAND_LINEAR_SYSTEM_BET, props<{ isExpanded: boolean }>());

    static toggleSystemBetPick = createAction(BetslipSystemBetActions.TOGGLE_SINGLE_BET_PICK, props<{ pickId: PickId }>());

    static updateSystemTypeStakes = createAction(
        BetslipSystemBetActions.UPDATE_SYSTEM_TYPE_STAKES,
        props<{ systemTypes: { type: SystemSlipType; betCount: number }[] }>(),
    );

    static clickSystemTypeStake = createAction(
        BetslipSystemBetActions.CLICK_SYSTEM_TYPE_STAKE,
        props<{ betType: SystemSlipType; stakeAmount: number | null }>(),
    );

    static setSystemBetTypeStake = createAction(
        BetslipSystemBetActions.SET_SYSTEM_BET_TYPE_STAKE,
        props<{ systemType: SystemSlipType; stake: number | null; silent?: boolean; stakeStr?: string | null; betCount: number }>(),
    );

    static removeSystemBetTypeStake = createAction(BetslipSystemBetActions.REMOVE_SYSTEM_BET_TYPE_STAKE, props<{ systemTypeKey: string }>());

    static setSystemBetTypeStakeValue = createAction(
        BetslipSystemBetActions.SET_SYSTEM_BET_TYPE_STAKE_VALUE,
        props<{ systemTypeKey: string; stake: number | null; silent?: boolean; stakeStr?: string | null }>(),
    );

    static setSystemBetTypeEachWay = createAction(
        BetslipSystemBetActions.SET_SYSTEM_BET_TYPE_EACHWAY,
        props<{ systemType: SystemSlipType; isEachWay: boolean }>(),
    );

    static addPick = createAction(BetslipSystemBetActions.ADD_PICK, props<{ pickId: string; pickState: Partial<ISystemBetPickState> }>());
    static removePick = createAction(BetslipSystemBetActions.REMOVE_PICK, props<{ pickId: string }>());
    static updateOrder = createAction(BetslipSystemBetActions.UPDATE_PICK_ORDER, props<{ pickId: string; order: number }>());
    static requestRemovePick = createAction(BetslipSystemBetActions.REQUEST_REMOVE_PICK, props<{ pickId: string }>());

    static addPickWithNewPickId = createAction(BetslipSystemBetActions.ADD_PICK_WITH_NEW_PICKID);
}
